import React from 'react';
import { Button } from '../ui/button';
import { X } from 'lucide-react';
import { cn } from '../../lib/utils';

const ChatbotInitAction = ({ chatConfigurationStyle, handleChatbotOpen, clickFromIcon, setClickFromIcon, handleSendMessage, sendMessageEventToParent, showFaqs, setShowFaqs, isOpen, setIsOpen }) => {
  return (
    <div className='flex flex-col items-end justify-end' onLoad={() => sendMessageEventToParent(false)} id='chatbotInitAction'>
      {/* <motion.div
        initial={{ opacity: 0.7, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ type: "spring", duration: 0.2, delay:0.2 }}
      >
        <div className='relative w-full group'>
          {showFaqs && !isOpen && (
            <div className='faqs-list-main'>
              <span><X
                className='absolute right-0 top-0 w-5 h-5 cursor-pointer mb-3 faqs-close-icon'
                onClick={() => { setShowFaqs(false); sendMessageEventToParent(true) }}
              /> .</span>
              <div className='w-full flex flex-col items-end max-h-full overflow-y-auto scrollbar-thin'>
                {chatConfigurationStyle?.faqs?.map((faq, index) =>
                  <span onClick={() => { handleSendMessage(faq); handleChatbotOpen(); }} key={index} style={{ background: chatConfigurationStyle?.messageColor }} className='cursor-pointer text-[14px] my-1.5 block p-2.5 rounded-br-none rounded-sm w-fit'>{faq?.question}</span>
                )}
              </div>
            </div>
          )}
        </div>
      </motion.div> */}

      <Button
        id='chatbotTriggerIcon'
        className={cn("py-2.5 px-4 h-auto rounded-full text-md text-primary-foreground transition-[0.5s]", isOpen && 'px-2.5')}
        onClick={() => {
          if (isOpen) {
            setIsOpen(false);
          } else {
            setIsOpen(true);
            setClickFromIcon(true);
          }
        }}
      >{
          isOpen ? <X className='object-contain w-6 h-6' /> :
            <><img className='object-contain w-[25px] h-[25px] mr-1.5' src={`${process.env.REACT_APP_S3_BASE_URL}/${chatConfigurationStyle?.icon}`} alt="Chat Icon" /> Chat</>
        }
      </Button>
    </div>
  )
}

export default ChatbotInitAction